import React, { Component } from "react";
import PageHelmet from "../component/common/Helmet";
import Breadcrumb from "../elements/common/Breadcrumb";
import WhatsAppButton from "../component/WhatsAppButton";
import ScrollToTop from "react-scroll-up";
import { FiChevronUp } from "react-icons/fi";
import Header from "../component/header/Header";
import Footer from "../component/footer/Footer";

import serviceImg from "../assets/images/service/service-01.png";
import serviceImg2 from "../assets/images/service/service-02.png";

import { withTranslation } from 'react-i18next';

class ServiceDetails extends Component {
  constructor() {
    super();
    this.state = {
      isOpen: false,
    };
    this.openModal = this.openModal.bind(this);
  }
  openModal() {
    this.setState({ isOpen: true });
  }
  render() {

    const { t } = this.props;

    return (
      <React.Fragment>
        {/* Start Pagehelmet  */}
        <PageHelmet pageTitle = {t("Caracteristicas")} />
        {/* End Pagehelmet  */}

        <Header
          headertransparent="header--transparent"
          colorblack="color--black"
          logoname="logo.png"
        />

        {/* Start Breadcrump Area */}
        <Breadcrumb title = {t("Caracteristicas")} />
        {/* End Breadcrump Area */}

        {/* Start Page Wrapper */}
        <div className="rn-service-details ptb--120 bg_color--1">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="service-details-inner">
                  <div className="inner">
                    {/* Start Single Area */}
                    <div className="row sercice-details-content pb--80 align-items-center">
                      <div className="col-lg-6 col-12">
                        <div className="thumb">
                          <img
                            className="w-100"
                            src={serviceImg}
                            alt="Service Images"
                          />
                        </div>
                      </div>
                      <div className="col-lg-6 col-12">
                        <div className="details mt_md--30 mt_sm--30">
                          <h4 className="title">{t("PvsF titulo 1")}</h4>
                          <p dangerouslySetInnerHTML={{ __html: t('parrafo-1') }} />
                          <h4 className="title">{t("PvsF titulo 2")}</h4>
                          <ul className="liststyle">
                            <li dangerouslySetInnerHTML={{ __html: t('propiedad 1') }} />
                            <li dangerouslySetInnerHTML={{ __html: t('propiedad 2') }} />
                            <li dangerouslySetInnerHTML={{ __html: t('propiedad 3') }} />
                            <li dangerouslySetInnerHTML={{ __html: t('propiedad 4') }} />
                            <li dangerouslySetInnerHTML={{ __html: t('propiedad 5') }} />
                            <li dangerouslySetInnerHTML={{ __html: t('propiedad 6') }} />
                          </ul>
                        </div>
                      </div>
                    </div>
                    {/* End Single Area */}

                    {/* Start Single Area */}
                    <div className="row sercice-details-content align-items-center">
                      <div className="col-lg-6 col-12 order-2 order-lg-1">
                        <div className="details mt_md--30 mt_sm--30">
                          <h4 className="title">{t("PvsF titulo 3")}</h4>
                          <p dangerouslySetInnerHTML={{ __html: t('parrafo-2') }} />
                          <h4 className="title">{t("PvsF titulo 4")}</h4>
                          <ul className="liststyle">
                            <li dangerouslySetInnerHTML={{ __html: t('propiedad 7') }} />
                            <li dangerouslySetInnerHTML={{ __html: t('propiedad 8') }} />
                            <li dangerouslySetInnerHTML={{ __html: t('propiedad 9') }} />
                            <li dangerouslySetInnerHTML={{ __html: t('propiedad 10') }} />
                            <li dangerouslySetInnerHTML={{ __html: t('propiedad 11') }} />
                          </ul>
                        </div>
                      </div>
                      <div className="col-lg-6 col-12 order-1 order-lg-2">
                        <div className="thumb position-relative">
                          <img
                            className="w-100"
                            src={serviceImg2}
                            alt="Service Images"
                          />
                        </div>
                      </div>
                    </div>
                    {/* End Single Area */}

                    {/* Start Single Area */}
                    <div className="sercice-details-content align-items-center">
                      <div className="details mt_md--30 mt_sm--30">
                        <h4 className="title">{t("PvsF titulo 5")}</h4>
                        <p dangerouslySetInnerHTML={{ __html: t('parrafo-3') }} />
                      </div>
                    </div>
                    {/* End Single Area */}
                    
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* End Page Wrapper */}

        {/* Start Whatsapp Button */}
        <div>
          <WhatsAppButton />
        </div>
        {/* End Whatsapp Button */}

        {/* Start Back To Top */}
        <div className="backto-top">
          <ScrollToTop showUnder={160}>
            <FiChevronUp />
          </ScrollToTop>
        </div>
        {/* End Back To Top */}

        <Footer />
      </React.Fragment>
    );
  }
}

export default withTranslation()(ServiceDetails);
